module.exports = __webpack_public_path__ + "img/twig-cafe-badge.c198324e.png";